import {
  GET_MENU,
  GET_MENU_FAIL,
  GET_MENU_RESET,
  GET_MENU_SUCCESS,
} from "./actionTypes";

const initialState = {
  menu: { items: [], accessLink: [] },
  loadingMenu: false,
  errorMenu: null,
};

const menu = (state = initialState, action) => {
  switch (action.type) {
    case GET_MENU:
      return {
        ...state,
        loadingMenu: true,
        menu: { items: [], accessLink: [] },
        errorMenu: null,
        type: action.type,
      };
    case GET_MENU_SUCCESS:
      let accessLink = [];
      const MORE_URL = {
        "/job-title-management/list": ["/job-title-management/create"],
        "/employee-management/list": ["/employee-management/create"],
        "/business-unit-management/list": ["/business-unit-management/create"],
        "/job-position-management/list": ["/job-position-management/create"],
      };
      for (const item of action.payload) {
        if (item.accessLink) {
          if (MORE_URL[item.accessLink]) {
            accessLink = accessLink.concat(MORE_URL[item.accessLink]);
          }
          accessLink.push(item.accessLink);
        }
        for (const child of item.children) {
          if (child.accessLink) {
            if (MORE_URL[child.accessLink]) {
              accessLink = accessLink.concat(MORE_URL[child.accessLink]);
            }
            accessLink.push(child.accessLink);
          }
        }
      }
      return {
        ...state,
        loadingMenu: false,
        errorMenu: null,
        menu: { items: action.payload, accessLink, success: true },
        type: action.type,
      };
    case GET_MENU_FAIL:
      return {
        ...state,
        loadingMenu: false,
        errorMenu: action.payload,
        type: action.type,
      };
    case GET_MENU_RESET:
      return {
        ...state,
        loadingMenu: false,
        errorMenu: null,
        menu: { items: [] },
        type: action.type,
      };
    default:
      return state;
  }
};

export default menu;
